import axios from "axios";

export default class PermissionService {
    getData() {
        return axios.get('/permissions/list_all_permissions',)
            .then(res => res.data);
    }
}
